import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MentionsLegales from "../pages/mentions-legales/page";
import ToituresTerrassesPage from "../pages/services/toitures-terrasses/page";
import ParkingsPage from "../pages/services/parkings/page";
import DallesCarrossablesPage from "../pages/services/dalles-carrossables/page";
import TerrassesPage from "../pages/services/terrasses/page";
import EtancheiteIsolationPage from "../pages/services/etancheite-isolation/page";
import MembranesBitumineusesPage from "../pages/services/membranes-bitumineuses/page";
import EtancheiteLiquidePage from "../pages/services/etancheite-liquide/page";
import GeomembranesEPDMPage from "../pages/services/geomembranes-epdm/page";
import RefectionEtancheitePage from "../pages/services/refection-etancheite/page";
import NotreApprochePage from "../pages/notre-approche/page";
import ContactPage from "../pages/contact/page";
import DevisPage from "../pages/devis/page";
import BlogPage from "../pages/blog/page";
import BlogArticlePage from "../pages/blog/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/services/toitures-terrasses",
    element: <ToituresTerrassesPage />,
  },
  {
    path: "/services/parkings",
    element: <ParkingsPage />,
  },
  {
    path: "/services/dalles-carrossables",
    element: <DallesCarrossablesPage />,
  },
  {
    path: "/services/terrasses",
    element: <TerrassesPage />,
  },
  {
    path: "/services/etancheite-isolation",
    element: <EtancheiteIsolationPage />,
  },
  {
    path: "/services/membranes-bitumineuses",
    element: <MembranesBitumineusesPage />,
  },
  {
    path: "/services/etancheite-liquide",
    element: <EtancheiteLiquidePage />,
  },
  {
    path: "/services/geomembranes-epdm",
    element: <GeomembranesEPDMPage />,
  },
  {
    path: "/services/refection-etancheite",
    element: <RefectionEtancheitePage />,
  },
  {
    path: "/notre-approche",
    element: <NotreApprochePage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/devis",
    element: <DevisPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
